import { ASSET } from './constants';

export type HeroAgeSlide = {
  id: 'kids' | 'teens' | 'adults';
  label: string;
  description: string;
  src: string;
  alt: string;
};

export const HERO_AGE_SLIDES: HeroAgeSlide[] = [
  {
    id: 'kids',
    label: 'Kids',
    description: 'Favorites, routines, and home categories',
    src: ASSET('screenshots/IMG_4455-2.PNG'),
    alt: 'Azalea kids home screen with routines and categories',
  },
  {
    id: 'teens',
    label: 'Teens',
    description: 'Portrait faces and teen-friendly phrases',
    src: ASSET('screenshots/hero-teens-feelings.png'),
    alt: 'Azalea teens feelings screen with portrait photo cards',
  },
  {
    id: 'adults',
    label: 'Adults',
    description: 'Calmer layout and everyday phrases',
    src: ASSET('screenshots/hero-adults-feelings.png'),
    alt: 'Azalea adults feelings screen with portrait photo cards',
  },
];
